var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"uploadfile-showImg",on:{"mousewheel":function($event){return _vm.bbimg(this)}}},[_c('img',{staticClass:"imgclass",style:(_vm.test),attrs:{"src":_vm.imgUrl,"alt":""},on:{"mousedown":_vm.imgMove}})])])}
var staticRenderFns = []

export { render, staticRenderFns }